import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={handleClick}
      data-no-print="true"
      data-testid="back-to-top-btn"
      className={`fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-[#E63946] hover:bg-[#1D3557] text-white border-3 border-[#1D3557] flex items-center justify-center transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      style={{ boxShadow: "0 6px 0 rgba(29, 53, 87, 0.25)" }}
    >
      <ArrowUp className="w-6 h-6" strokeWidth={3} />
    </button>
  );
};

export default BackToTop;
